import type { ReactElement } from 'react';
import { mergeSx } from 'components/ui/utilities/mergeSx';
import type { TextProps } from './Text.props';
import { StyledText, textDisplayTitleSx, textFieldInlineErrorSx, textFieldLabelSx, textInlineEmphasisSx } from './Text.styles';

const textVisualVariantSx = {
  displayTitle: textDisplayTitleSx,
  fieldInlineError: textFieldInlineErrorSx,
  fieldLabel: textFieldLabelSx,
  inlineEmphasis: textInlineEmphasisSx,
} as const;

const Text = ({ sx, visualVariant, ...props }: TextProps): ReactElement => {
  const presetSx = visualVariant ? textVisualVariantSx[visualVariant] : undefined;
  const mergedSx = mergeSx(presetSx, sx);

  return <StyledText sx={mergedSx} {...props} />;
};

export default Text;
